app.factory("StripePaymentFactory", [
  "$http",
  "config",
  "decrypt",
  "$q",
  function ($http, config, decrypt, $q) {
    return {
      recordPaymentPostdata(piID, cart) {
        return {
          cart: JSON.stringify(cart),
          piID: piID,
        };
      },
      stripeConnectToken() {
        let q = $q.defer();
        $http({
          method: "GET",
          url: config.fstreamAPI + "getStripePublishableToken",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }).then(
          function success(response) {
            q.resolve(response.data.data.stripeToken);
          },
          function error(response) {
            q.reject(response);
          }
        );
        return q.promise;
      },
      stripeIntentKey() {
        let q = $q.defer();
        $http({
          method: "GET",
          url: config.fstreamAPI + "getStripePublicKey",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }).then(
          function success(response) {
            q.resolve(response.data.data.stripePublicKey);
          },
          function error(error) {
            q.reject(error);
          }
        );
        return q.promise;
      },
      stripeConnectIntent(postdata) {
        let q = $q.defer();
        $http({
          method: "POST",
          url: config.fstreamAPI + "setStripePaymentIntent",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function mySucces(response) {
            q.resolve(response.data.data.intentSecret);
          },
          function myError(response) {
            q.resolve(false);
          }
        );
        return q.promise;
      },
      stripeIntentIntent(postdata) {
        let q = $q.defer();
        $http({
          method: "POST",
          url: config.fstreamAPI + "setupPaymentIntent",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function mySucces(response) {
            q.resolve(response.data.data.clientSecret);
          },
          function myError() {
            q.resolve(false);
          }
        );
        return q.promise;
      },
      recordStripeConnectPayment(postdata) {
        let q = $q.defer();
        $http({
          method: "POST",
          url: config.fstreamAPI + "recordStripeConnectPayment",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function mySucces(response) {
            q.resolve(true);
          },
          function myError(response) {
            q.resolve(false);
          }
        );
        return q.promise;
      },
      fulfillPaymentIntent(postdata) {
        let q = $q.defer();
        $http({
          method: "POST",
          url: config.fstreamAPI + "fulfillPaymentIntent",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: postdata,
        }).then(
          function mySucces(response) {
            q.resolve(true);
          },
          function myError(response) {
            q.resolve(false);
          }
        );
        return q.promise;
      },
    };
  },
]);
